import React, { FunctionComponent } from 'react';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CircleArrowIcon from '@components/basics/icons/circle-arrow';
import SeparatorLine from '@components/basics/separator-line';
import DetailItem, { DetailItemProps } from './detail-item';

export interface EarningsBoxDetailItem {
  id: string;
  title: React.ReactNode;
  icon?: React.JSX.Element;
  totalEarnings: Dinero.Dinero;
  details: DetailItemProps[];
  isFirst?: boolean;
}

interface DetailBoxItemProps extends EarningsBoxDetailItem {
  className?: string;
}

const DetailBoxItem: FunctionComponent<DetailBoxItemProps> = ({
  className,
  id,
  title,
  icon,
  isFirst,
  totalEarnings,
  details,
}) => {
  const [openDetails, setOpenDetails] = React.useState<string>(
    isFirst ? id : ''
  );

  return (
    <Box style={{ backgroundColor: 'transparent' }} className={className || ''}>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex justifyContent="flex-start" alignItems="center" gap={16}>
          {icon}
          <Typography type="big-title" customFont="medium">
            {title}
          </Typography>
        </Flex>
        <Flex justifyContent="flex-end" alignItems="center" gap={16}>
          {totalEarnings && (
            <Typography type="big-title" customFont="semi-bold" align="right">
              {totalEarnings.toFormat()}
            </Typography>
          )}
          <CircleArrowIcon
            size="32"
            isWhite
            arrowUp={openDetails === id}
            onClick={() => setOpenDetails(openDetails ? '' : id)}
          />
        </Flex>
      </Flex>
      {openDetails === id &&
        details.map((detail, index) => (
          <DetailItem
            key={detail.id}
            id={`${detail.id}_${index}`}
            title={detail.title}
            titleHelper={detail.titleHelper}
            earned={detail.earned}
            subtitle={detail.subtitle}
            items={detail.items}
            isSimplified={detail.isSimplified}
          />
        ))}
      <SeparatorLine />
    </Box>
  );
};

export default DetailBoxItem;
